module.exports = __webpack_public_path__ + "static/media/Group 42.d05faa1a.png";